import { ButtonDropdown, CardBody, Dropdown, Form, Modal, Table, UncontrolledButtonDropdown, UncontrolledDropdown } from 'reactstrap'
import styled from 'styled-components'
import { CONSTANTS } from 'utils/helpers'
import ReactSelect from 'react-select'

export const colors = {
  'main-text': '#181818',
  'split-black': '#31373f',
  'text-secondary': '#7F82A1',
  gray: '#96a5b3',
  'gray-200': '#F5F7FA',
  pink: '#F3A0AE',
  'main-blue': '#0d55ff',
  'split-blue': '#3974ff',
  'blue-secondary': '#CFDDFF',
  'blue-100': '#E7EEFF',
  'lightest-blue': '#fbfbff',
  'light-blue-100': '#f4f4ff',
  'light-blue-100-opacity': '#f4f4ff66',
  'light-blue-200': '#e3e7f0',
  'light-blue-300': '#C8D1E5',
  green: '#48d783',
  red: '#ff3e3e',
  danger: '#FF4343'
}

export const ContentBox = styled.div`
  transition: margin-left 0.35s ease-out;
  @media (min-width: 1200px) {
    margin-left: ${(props) => (props.isMainMenuOpen ? `${CONSTANTS.mainMenuMinWidth}px` : '0px')};
  }
`

export const ToolBar = styled.ul`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  padding: 15px;
  flex-wrap: wrap;
  @media (min-width: 576px) {
    padding: 25px 30px 15px;
    flex-wrap: none;
  }
  list-style: none;
  & > li {
    margin: 0 10px;
    cursor: pointer;
    position: relative;
    & > svg {
      width: 25px;
      height: 25px;
    }

    &.has-menu {
      nav {
        z-index: 9981;
        visibility: hidden;
        position: absolute;
        opacity: 0;
        transition: 0.3s;
        width: 200px;
        right: 0px;
        top: 35px;
        border-radius: 2px;
        border-style: solid;
        border-width: 1px;
        background-color: #ffffff;
        border-color: #eeeeee;
        text-align: left;
        ul {
          margin: 0;
          padding: 0;
          box-shadow: 0px 20px 40px rgb(3 11 31 / 10%);
        }
        li {
          display: block;
          text-decoration: none;
          padding: 15px 11px;
          color: #00263a;
          transition: 0.1s;
          font-weight: normal;
          cursor: pointer;
          font-size: 1rem;
          display: flex;
          align-items: center;
          &:hover {
            background-color: ${colors['light-blue-100']};
          }
          svg {
            color: #181818;
            margin-right: 8px;
            width: 1.5rem;
            height: 1.5rem;
          }
          &.smallIcon {
            svg {
              width: 1.4rem;
              height: 1.4rem;
            }
          }
        }
        .menuSeparater {
          border: none;
          border-top: 1px solid #ececec;
          border-left: 15px solid transparent;
          border-right: 15px solid transparent;
          margin-top: 0;
          margin-bottom: 0;
        }
      }
      &.clicked nav {
        visibility: visible;
        opacity: 1;
      }
      &.hideDropDown nav {
        visibility: hidden;
        opacity: 0;
      }
    }

    nav.product-updates {
      width: 350px;
    }

    &.li-global-search {
      @media (max-width: 576px) {
        width: 100%;
        order: 3;
        margin-left: 0 !important;
        margin-top: 16px;
      }
    }
  }
`

export const ProfileInfo = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
`
export const ProfilePhoto = styled.div`
  width: ${(props) => (props.size ? props.size : 32)}px;
  min-width: ${(props) => (props.size ? props.size : 32)}px;
  height: ${(props) => (props.size ? props.size : 32)}px;
  font-size: ${(props) => (props.size ? props.size * 0.56 : 18)}px;
  overflow: hidden;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.5;
  box-shadow: 0px 4px 15px -6px rgba(11, 12, 8, 0.4);
  background: ${(props) => (props.color ? colors[props.color] : colors['text-secondary'])};
  border: 1px solid rgba(0, 0, 0, 0.1);
  color: #fff;
`
export const ModalForm = styled(Form)`
  .title {
    font-weight: bold;
    font-family: 'PT Serif';
    font-size: 24px;
    line-height: 1;
    position: relative;
    margin-bottom: 30px;
    text-transform: capitalize;
    &:before {
      content: '';
      position: absolute;
      left: 0;
      bottom: -15px;
      width: 32px;
      height: 2px;
      background: ${colors['main-blue']};
    }
  }
  .form-group {
    label {
      font-size: 12px;
      -webkit-text-fill-color: ${colors['text-secondary']};
      color: ${colors['text-secondary']};
      margin-bottom: 0;

      & span.optional-flag{
        font-size: 8px;
      }
    }
  }
`
export const LockedModal = styled.div`
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 7rem;
    p {
      text-align: center;
      margin-bottom: 3rem;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: #06112c;
      font-family: Helvetica;
    }
    button {
      .lockIcon {
        margin-right: 5px;
        transform: translateY(-3px);
      }
    }
  }
  .title {
    font-weight: 400;
    font-family: 'PT Serif';
    font-size: 24px;
    line-height: 1;
    position: relative;
    margin-bottom: 30px;
    text-transform: capitalize;
    display: flex;
    flex-direction: column;
    align-items: center;
    &:before {
      content: '';
      position: absolute;
      left: 40%;
      right: 40%;
      bottom: -15px;
      width: 20%;
      height: 2px;
      background: ${colors['main-blue']};
    }
    svg {
      margin-top: 1rem;
      margin-bottom: 4rem;
    }
  }
`

export const SettingsList = styled.ul`
  li {
    margin: 16px 0;
    &:hover {
      font-weight: 500;
    }
  }
  li.section-title {
    font-weight: 600;
    -webkit-text-fill-color: ${colors['text-secondary']};
    color: ${colors['text-secondary']};
  }
  li.setting-item {
    label {
      cursor: pointer;
    }
  }
`

export const MoreButton = styled(UncontrolledDropdown)`
  &.dropleft.show {
    .btn.toggle {
      position: relative;
      &:before {
        content: '';
        position: absolute;
        border: 6px solid transparent;
        border-left-color: ${colors['main-blue']};
        top: 6px;
        left: -10px;
      }
    }
  }
  .dropdown-menu {
    border: 1px solid ${colors['light-blue-100']};
    padding: 8px 0;
    border-radius: 0;
    min-width: 200px;
    &:before {
      content: '';
      position: absolute;
      border: 6px solid transparent;
      left: calc(50% - 6px);
    }
    &[x-placement^='bottom'] {
      border-top: 2px solid ${colors['main-blue']};
      margin-top: 6px;
      &:before {
        top: -14px;
        border-bottom: 6px solid ${colors['main-blue']};
      }
    }
    &[x-placement^='top'] {
      border-bottom: 2px solid ${colors['main-blue']};
      margin-top: 0px;
      &:before {
        bottom: -14px;
        border-top: 6px solid ${colors['main-blue']};
      }
      &.horizontal-center {
        transform: translate3d(-42%, -110%, 0) !important;
      }
    }
    &[x-placement^='left-start'] {
      border-right: 2px solid ${colors['main-blue']};
      padding-top: 12px;
      // &:after {
      //   content: '';
      //   position: absolute;
      //   top: 0;
      //   right: -25px;
      //   bottom: 0;
      //   width: 25px;
      // }
    }
    .dropdown-item {
      cursor: pointer;
      padding: 12px 15px;
      border: none !important;
      display: flex;
      align-items: center;
      &:active,
      &.active {
        color: #fff !important;
      }
      svg {
        margin-right: 8px;
      }
      &.delete {
        padding: 12px 15px;
      }
    }
    .divider {
      width: 100%;
      height: 1px;
      background-color: #f7faff;
      margin-top: 8px;
      padding: 0;
    }
  }
  &.more-button-dropdown {
    display: flex;
    justify-content: flex-end;
    .dropdown-menu {
      width: auto;
      left: -8px !important;
      box-shadow: 0 4px 8px rgb(24 24 24 / 20%);
    }
    button.toggle {
      padding: 0;
      width: 30px;
      height: 30px;
      border: none;
    }
    &.show button.toggle {
      display: flex !important;
    }

    &.arrow::after{
      content: "";
      position: absolute;
      border-width: 6px;
      border-style: solid;
      border-color: transparent rgb(13, 85, 255) transparent transparent;
      border-image: initial;
      top: 6px;
      right: -8px;
      z-index: 3;
    }
  }

  .categories-submenu {
    max-height: 300px;
    overflow: auto;
  }
`

export const UsersSelectable = styled.div`
  display: flex;
  .category__control {
    border: none;
    border-bottom: 1px solid ${colors['light-blue-200']};
    border-radius: 0;
    &:hover {
      border-color: ${colors['light-blue-200']};
      box-shadow: none;
    }
  }
  .category__menu {
    z-index: 10;
  }
  .category {
    position: relative;
    z-index: 10;
    display: flex;
    margin-bottom: 32px;
    .category__control {
      width: 400px;
    }
  }
  .usermultiselect {
    width: 100%;
  }
`

export const PageTitle = styled.h2`
  font-weight: 700;
  font-size: 1.5rem;
  font-family: 'PT Serif', sans-serif;
  display: flex;
  align-items: center;
  @media (min-width: 576px) {
    font-size: 2.8rem;
    padding-right: 45px;
  }
`
export const Subtitle = styled.h4`
  font-size: 12px;
  font-weight: 600;
  -webkit-text-fill-color: ${colors['text-secondary']};
  color: ${colors['text-secondary']};
`

export const GeneralTable = styled(Table)`
  border-bottom: 1px solid #dee2e6;
  thead {
    th {
      border-top: none;
      border-bottom: 1px solid ${colors['main-text']};
    }
  }
  tbody {
    td {
      padding: 16px 8px;
      background: ${colors['lightest-blue']};
      vertical-align: middle;

      // Freemium disabled
      .content-link {
        position: relative;
        &.disabled {
          padding: 5px;
          pointer-events: none;
          .show-upgrade-button {
            display: flex;
          }
        }
      }
      .action-buttons svg {
        width: 24px;
        height: 24px;
      }
    }
  }
`

export const AvatarSelector = styled.label`
  position: relative;
  input[type='file'] {
    display: none;
  }
  .preview {
    cursor: pointer;
    background: ${colors['blue-secondary']};
    width: 72px;
    height: 72px;
    border-radius: 72px;
    overflow: hidden;
    border: 3px solid ${colors['blue-100']};
    position: relative;
    img,
    svg {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    svg.placeholder {
      top: 38%;
    }
  }
  .remove {
    position: absolute;
    top: -10px;
    right: -10px;
    border-radius: 24px;
    z-index: 1;
    background: ${colors['lightest-blue']};
    &:hover {
      box-shadow: 0px 0px 4px ${colors['split-black']};
    }
  }
  .upload-logo-placeholder {
    position: absolute;
    bottom: 0;
    font-size: 10px;
    text-align: center;
    background: ${colors['blue-100']};
    left: 0;
    right: 0;
    padding: 0 3px;
  }
`
export const InsertButtonStyled = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 60000000000;
  background: #fff;
  white-space: nowrap;
  padding-top: 27px;
  @media (min-width: 576px) {
    padding-top: 25px;
  }

  &.fr-sticky-on {
    position: fixed;
    z-index: 10;
    left: auto;
    z-index: 12 !important;
  }

  .toggle-button {
    cursor: pointer;
  }
  .button {
    cursor: pointer;
    padding: 4px 5px;
    border-radius: 4px;
    margin: 0px 3px;
    &.active {
      background: ${colors['blue-100']};
    }
    &:hover {
      background: ${colors['light-blue-100']};
    }
  }
  .InsertDropdownButton {
    border: none;
    display: flex;
    align-items: center;
    background: ${colors['light-blue-100']};
    width: 24px;
    @media (min-width: 576px) {
      width: 100px;
      overflow: hidden;
    }
    border-radius: 12px;
    padding: 0;
    z-index: 3;
    .insertIcon {
      background: ${colors['main-text']};
      width: 20px;
      height: 20px;
      @media (min-width: 576px) {
        width: 24px;
        height: 24px;
      }
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        fill: #fff;
        width: 20px;
        height: 20px;
      }
    }
    &:hover {
      background: ${colors['blue-100']};
      .insertIcon {
        background: ${colors['main-blue']};
      }
    }
  }

  /* Dropdown Items */
  .dropdown-menu {
    top: 18px;
    z-index: 2;
    min-width: 210px;
    right: auto;
    border: none;
    box-shadow: ${CONSTANTS.toolbarDDShadow};
    .dropdown-item .has-submenu {
      display: flex;
      align-items: center;
      justify-content: space-between;
      svg {
        fill: ${colors['text-secondary']};
      }
    }
    .dropdown-item:not(.disabled) {
      cursor: pointer;
      padding: 6px 7px 6px 15px;
      &:not(.nohover):hover {
        font-weight: 600;
        color: ${colors['main-text']};
        background: ${colors['blue-100']};
        .has-submenu {
          svg {
            fill: ${colors['main-text']};
          }
        }
      }
      &.nohover:hover {
        background: none;
      }
    }

    &.more-formats {
      .dropdown-item:not(.disabled) {
        display: flex;
        justify-content: center;
        padding: 10px 15px;
        svg {
          width: 16px;
          height: 16px;
        }
      }
    }

    &.text-color-picker {
      padding: 0;
      .dropdown-item:not(.disabled) {
        padding: 16px 8px 8px 16px;
        display: flex;
        width: 224px;
        flex-wrap: wrap;
        .color-item {
          width: 32px;
          height: 32px;
          border-radius: 32px;
          margin-right: 8px;
          margin-bottom: 8px;
          position: relative;
          &:hover:before {
            content: '';
            position: absolute;
            top: -3px;
            right: -3px;
            bottom: -3px;
            left: -3px;
            border: 2px solid ${colors['blue-secondary']};
            border-radius: 32px;
          }
        }
      }
    }

    .submenu {
      margin-left: 4px;
      margin-top: -11px;
      .dropdown-item:not(.disabled) {
        padding: 6px 7px 6px 15px;

        /* callout-item */
        &.callout-item {
          padding: 6px 8px;
          width: 100%;
          text-align: center;
          & > div {
            padding: 6px 30px;
            border-radius: 3px;
            font-size: 12px;
            font-weight: 600;
            &.alert-danger {
              background-color: #ffe3e3;
            }
            &.alert-warning {
              background-color: #ffefcf;
            }
            &.alert-primary {
              background-color: ${colors['light-blue-100']};
            }
            &.alert-success {
              background-color: #c9ffe0;
            }
          }
        }

        /* Emoji Picker */
        &.emoji-picker {
          padding: 6px;
          .emoji-picker-react {
            .native {
              font-size: 20px;
              margin: 3px;
            }
            .emoji-categories,
            .content-wrapper {
              padding: 0 10px;
            }
            .emoji-search {
              width: calc(100% - 20px);
              margin: 0 auto;
              line-height: 1.5;
              padding: 5px;
              display: block;
            }
            .emoji-group:before {
              font-size: 11px;
            }
          }
        }

        // Table
        &.insert-table {
          padding: 0;
          .fr-table-size {
            padding: 8px;
            display: flex;
            flex-wrap: wrap;
            width: 176px;
            margin: 0 auto !important;
            .fr-table-size-info {
              font-weight: normal;
            }
            .fr-select-table-size {
              padding: 0;
              & > span {
                display: inline-block;
              }
            }
          }
        }
      }
    }
  }

  .file-upload {
    input[type='file'] {
      position: absolute;
      opacity: 0;
      z-index: -1;
    }
  }
`

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  border-top: .1px solid #727377;
  z-index: 6;
  background: transparent;
  padding: 1rem 0;
  .action-buttons {
    display: flex;
    align-items: center;
    @media (max-width: 576px) {
      justify-content: space-around;
      width: 100%;
    }
  }
`

export const AutosaveIndicator = styled.div`
  text-transform: capitalize;
  font-weight: 600;
  svg {
    width: 20px;
    height: 20px;
  }
`

export const Colortabs = styled.ul`
  width: 100%;
  li {
    &.active {
      color: ${colors['main-blue']};
    }
  }
`

export const ToolbarSeparator = styled.div`
  height: 24px;
  width: 1px;
  margin: 0 8px;
  background: ${colors['light-blue-200']};
`

export const NotificationDropdown = styled(Dropdown)`
  & > * {
    z-index: ${props => props.isfullscreen ? `30000000000` : `10`};
  }

  button.btn-toggle {
    border: none;
    background: transparent;
    width: 32px;
    height: 32px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    &:focus,
    &:active {
      box-shadow: none;
      background: transparent !important;
    }
    &[aria-expanded='true'] {
      background: #fff !important;
    }
    .new-mark {
      position: absolute;
      top: 4px;
      right: 6px;
      width: 8px;
      height: 8px;
      background: ${colors.red};
      border: 1px solid #fff;
      border-radius: 10px;
    }
  }
  & > .dropdown-menu {
    width: 97vw;
    @media (min-width: 576px) {
      width: 435px;
    }
    min-height: 240px;
    max-height: 550px;
    overflow: hidden;
    top: 0 !important;
    border: none;
    border-radius: 0;
    .dropdown-header {
      padding: 25px 25px 15px;
      font-size: 14px;
      font-weight: 600;
      color: ${colors['main-text']};
      span.title {
        font-family: 'PT Serif';
        font-size: 1.5rem;
      }
    }
    div.notification-items {
      max-height: calc(550px - 150px);
      padding-bottom: 10px;
      overflow-y: auto;
      div.notification {
        padding: 15px 25px;
        border-bottom: 1px solid ${colors['light-blue-100']};
        &:hover {
          border-bottom: 1px solid ${colors['light-blue-200']};
        }
      }
    }
    .sub-menu {
      border: none;
      width: auto;
      border-bottom: 1px solid #e8e8e8;
      background: #f9f4fd;
      box-shadow: 0px 0px 0px 0px #000;
      &:before {
        border: none;
      }
      .dropdown-item {
        svg {
          margin-right: 8px;
          width: 20px;
          height: 20px;
        }
      }
    }
  }
`
export const NotificationStyled = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
  .unread-mark {
    min-width: 8px;
    height: 8px;
    margin-top: 7px;
    margin-left: auto;
    border-radius: 8px;
    background: ${colors['main-blue']};
  }
  small {
    -webkit-text-fill-color: ${colors['text-secondary']};
    color: ${colors['text-secondary']};
  }
`

export const AllNotificationsStyled = styled.div`
  min-height: 240px;
  max-height: 530px;
  overflow: auto;
  div.notification {
    cursor: pointer;
    padding: 16px 0;
    border-bottom: 1px solid ${colors['light-blue-100']};
    &:hover {
      border-bottom: 1px solid ${colors['light-blue-200']};
    }
    &:last-of-type {
      border-bottom: none;
    }
  }
`

export const ChangeLogitems = styled.div`
  padding: 0;
  list-style-type: none;
  box-shadow: none !important;
  margin-bottom: 15px;
  .changelog-item {
    padding-left: 10px;
    margin-bottom: 0;
    position: relative;
    margin: 0 7px;
    margin-bottom: 12px;
    .version_number {
      font-weight: 600;
      position: relative;
      padding-left: 15px;
      font-feature-settings: 'lnum';
    }
    .logContent {
      background: #e9edf5;
      border-radius: 4px;
      margin: 5px 0;
      padding: 5px;
      font-size: 0.8rem;
    }
    .version_number .bull {
      position: absolute;
      left: 0;
      font-size: 1.2rem;
      color: #5b72e6;
    }
    .logContent p {
      margin: 0;
    }
  }
`

export const ActionDropdown = styled(ButtonDropdown)`
  &.btn-group {
    button:not(.dropdown-toggle) {
      height: 32px;
      background: #fff;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      padding: 9px 12px;
      border: 1px solid ${colors['main-blue']};
      color: ${colors['main-blue']};
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: center;
      transition: 0s;
      box-shadow: 0px 4px 8px ${colors['main-text']}33;
      &.circle {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
      &:hover,
      &:focus,
      &:active {
        background: ${colors['blue-secondary']};
        color: ${colors['main-blue']};
        border: 1px solid ${colors['main-blue']};
        box-shadow: 0px 4px 8px ${colors['main-text']}33;
      }
      &.rounded-border {
        border-radius: 0;
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
      }

      &.black {
        background: ${colors['main-text']};
        border-color: ${colors['main-text']};
        color: #fff;
        &:not(:disabled):hover,
        &.active:not(:disabled) {
          background: ${colors['split-black']};
          border-color: ${colors['split-black']};
        }
      }
      &.gray {
        background: ${colors['light-blue-100']};
        border-color: ${colors['light-blue-100']};
        color: ${colors['main-text']};
        &:not(:disabled):hover,
        &.active:not(:disabled) {
          background: ${colors['light-blue-200']};
          border-color: ${colors['light-blue-200']};
        }
        &.hover-black:not(:disabled):hover {
          background: ${colors['main-text']};
          svg {
            stroke: #fff;
          }
          circle {
            fill: #fff;
          }
        }
      }
      &.green {
        &:not(.outlined) {
          border-color: ${colors['green']};
          background: ${colors['green']};
          color: #fff;
        }
      }
      &:disabled {
        background: ${colors['text-secondary']};
        border-color: ${colors['text-secondary']};
      }
    }

    button.dropdown-toggle {
      width: 32px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: none;
      box-shadow: none;
      &:before {
        content: '';
        position: absolute;
        top: calc(50% - 4px);
        width: 6px;
        height: 6px;
        border: 2px solid #fff;
        border-left: none;
        border-top: none;
        transform: rotate(45deg);
      }
      &:after {
        content: '';
        position: absolute;
        display: none;
        border-width: 6px;
        border-style: solid;
        border-color: transparent transparent transparent ${colors['main-blue']};
        top: 7px;
        left: -4px;
      }
      // &[aria-expanded='true']:after {
      //   display: block;
      // }
      &.black {
        background: ${colors['main-text']};
        border-color: ${colors['main-text']};
        color: #fff;
        border-left-color: #ffffff66;
        &:not(:disabled):hover,
        &.active:not(:disabled) {
          background: ${colors['split-black']};
          border-color: ${colors['split-black']};
        }
      }
      &.green {
        &:not(.outlined) {
          border-color: ${colors['green']};
          background: ${colors['green']};
          color: #fff;
        }
      }
      &.rounded-border {
        border-radius: 0;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
      }
      &:disabled {
        background: ${colors['text-secondary']};
        border-color: ${colors['text-secondary']};
      }
    }
    .dropdown-menu {
      border: 1px solid ${colors['light-blue-100']};
      padding-top: 12px 0px;
      border-radius: 0;
      min-width: 200px;
      position: absolute !important;
      left: 9px !important;
      border-left: 2px solid ${colors['main-blue']};
      box-shadow: 0 4px 8px rgb(24 24 24 / 20%);

      &:before {
        content: '';
        position: absolute;
        border: 6px solid transparent;
      }
      &[x-placement^='bottom'] {
        border-top: 2px solid ${colors['main-blue']};
        margin-top: 6px;
        &:before {
          top: -14px;
          border-bottom: 6px solid ${colors['main-blue']};
        }
      }
      &[x-placement^='top'] {
        border-bottom: 2px solid ${colors['main-blue']};
        margin-top: 0px;
        &:before {
          bottom: -14px;
          left: auto;
          right: 15px;
          border-top: 6px solid ${colors['main-blue']};
        }
        &.horizontal-center {
          transform: translate3d(-42%, -110%, 0) !important;
        }
      }
      &[x-placement^='left-start'] {
        border-right: 2px solid ${colors['main-blue']};
        padding-top: 12px;
      }
      .dropdown-item {
        cursor: pointer;
        padding: 12px 15px;
        border: none !important;
        display: flex;
        align-items: center;
        &:active,
        &.active {
          color: #fff !important;
        }
        svg {
          margin-right: 8px;
        }
        &.delete {
          padding: 12px 15px;
          margin: 12px 0 0;
        }
      }
      .divider {
        width: 100%;
        height: 1px;
        background-color: #f7faff;
        margin-top: 8px;
        padding: 0;
      }
    }

    &.up {
      button.dropdown-toggle {
        :before {
          border-width: 0px 0.3em 0.3em;
          border-top-style: initial;
          border-top-color: initial;
          border-right-style: solid;
          border-right-color: transparent;
          border-bottom-style: solid;
          border-bottom-color: initial;
          border-left-style: solid;
          border-left-color: transparent;
          transform: none;
        }
      }
      .dropdown-menu {
        padding: 3px 0px;
        box-shadow: rgb(24 24 24 / 20%) 0px 4px 8px;
        border-radius: 0px;
        top: -10px !important;
        button.dropdown-button {
          box-shadow: none;
          text-align: center;
          font-size: 16px;
          padding: 7px 20px;
          font-weight: 600;
          color: ${colors['main-text']};
          &:hover {
            background: ${colors['blue-100']};
            color: ${colors['main-blue']};
          }
        }
      }
    }
  }
`

export const FooterActionButtons = styled(UncontrolledButtonDropdown)`
  &.btn-group {
    width: 100%;
    button:not(.dropdown-button) {
      height: 32px;
      background: #fff;
      border-radius: 4px;
      font-size: 16px;
      font-weight: 600;
      padding: 4px 0px;
      border: 1px solid ${colors['main-blue']};
      color: ${colors['main-blue']};
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      transition: all 0s ease 0s;
      box-shadow: rgb(24 24 24 / 20%) 0px 4px 8px;
    }
    button.dropdown-toggle {
      width: 40px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
    .dropdown-menu {
      padding: 3px 0px;
      margin: 0px;
      min-width: 100%;
      box-shadow: rgb(24 24 24 / 20%) 0px 4px 8px;
      border: none;
      border-radius: 0px;
      top: -10px !important;
      .dropdown-item {
        text-align: center;
        font-size: 16px;
        padding: 7px 20px;
        font-weight: 600;
      }
    }
  }
`

export const FileInputHidden = styled.input`
  position: absolute;
  opacity: 0;
  z-index: -1;
  top: 0;
  left: 0;
  width: 0;
`

// Bulk Import CSV/Excel
export const ImportCategoryList = styled(CardBody)`
  padding: 8px;
  max-height: 300px;
  overflow: auto;
  .category-item {
    margin: 5px 0;
    padding: 5px 10px;
    border-radius: 5px;
    &:first-of-type,
    &:last-of-type {
      margin: 0;
    }
    cursor: pointer;
    &.active {
      background: ${colors['light-blue-100']};
      & > div.category_name {
        color: ${colors['main-blue']};
        font-weight: 700;
      }
    }
  }
`

export const ImportTabsContent = styled.div`
  overflow: auto;
  min-height: 120px;
  .CategoriesAccordion {
    padding: 0 !important;
  }
`

export const ImportTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    background-color: ${colors['lightest-blue']};
    padding: 15px;
    border: 1px solid ${colors['light-blue-200']};
    filter: grayscale(1);
    font-size: 16px;
    font-weight: 600;
    opacity: 0.6;
    display: flex;
    width: 48%;
    &.active {
      filter: none;
      opacity: 1;
      color: ${colors['main-text']};
    }
    .tab-name {
      padding-left: 13px;
      margin-left: 13px;
      position: relative;
      line-height: 2;
      flex: 1;
      text-align: center;
      &:before {
        content: '';
        border-left: 1px solid ${colors['light-blue-200']};
        height: 100%;
        width: 1px;
        position: absolute;
        left: 0;
      }
    }
  }
`

export const HomepageContentList = styled.ul`
  height: calc(100vh - 420px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  li {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    .content-title {
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 1rem;
      font-family: 'Raleway';
      font-weight: 600;
      padding-left: 22px;
      position: relative;
      span.icon {
        position: absolute;
        left: 0;
        top: 0;
        svg {
          width: 18px;
          height: 18px;
        }
      }
    }
    .meta {
      -webkit-text-fill-color: ${colors['text-secondary']};
      color: ${colors['text-secondary']};
      font-size: 85%;
      padding-left: 22px;
      display: inline-block;
      .separator-dot {
        display: inline-block;
        vertical-align: center;
        width: 5px;
        height: 5px;
        border-radius: 5px;
        margin: 0 5px;
        background: ${colors['light-blue-300']};
      }
    }
  }
`

export const TemplatesList = styled.div`
  margin-top: 16px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 576px) {
    max-height: 250px;
    overflow-y: auto;
    margin-bottom: 30px;
  }
  .templateBox {
    display: flex;
    align-items: center;
    position: relative;
    background: ${colors['lightest-blue']};
    padding: 14px;
    border: 1px solid ${colors['light-blue-200']};
    width: 100%;
    @media (min-width: 576px) {
      width: 24%;
    }
    margin-bottom: 16px;
    height: 70px;
    cursor: pointer;
    &:hover {
      background: ${colors['light-blue-200']};
    }
    .title-div {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 2rem;
      overflow: hidden;
      .icon {
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.7rem;
        margin-right: 5px;
      }
      .template-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 600;
        font-size: 1rem;
        display: inline-block;
        varticle-align: middle;
        svg {
          transform: rotate(180deg);
        }
      }
    }
    .more-button-dropdown {
      position: absolute;
      right: 15px;
      button.toggle {
        background: ${colors['light-blue-100']};
        border-radius: 20px;
        padding: 5px;
        width: 24px;
        height: 24px;
        @media (max-width: 1024px) {
          display: flex;
        }
        @media (min-width: 1025px) {
          display: none;
        }
      }
    }

    &:hover .more-button-dropdown button.toggle {
      display: flex;
    }
  }
`
export const ActivityGroup = styled.div`
  margin-bottom: 15px;
  .group-name {
    border-top: 1px solid ${colors['light-blue-200']};
    border-bottom: 1px solid ${colors['light-blue-200']};
    font-size: 12px;
    padding: 8px 25px;
  }
  .activity-item {
    padding: 8px 25px;
    .content-title {
      display: flex;
      align-items: center;
      .icon {
        transform: translateY(5px);
      }
    }
    .meta {
      font-size: 12px;
      padding-left: 40px;
      -webkit-text-fill-color: ${colors['text-secondary']};
      color: ${colors['text-secondary']};
    }
  }

  .hide-activity-padding{
    padding: 0 !important;
  }
`
export const ListContainer = styled.div`
  margin-bottom: 30px;
  @media (min-width: 576px) {
    min-height: 120px;
    max-height: calc(100vh - 435px);
    margin-bottom: 0;
  }
  overflow: auto;
  .example {
    border: 1px solid ${colors['light-blue-200']};
    background: ${colors['lightest-blue']};
    border-radius: 4px;
    padding: 15px 16px;
    font-weight: 700;
    position: relative;
    &:hover .remove {
      display: block;
      &:hover {
        background: ${colors['light-blue-200']};
      }
    }
    .remove {
      display: none;
      svg {
        width: 20px;
        height: 20px;
      }
      position: absolute;
      top: 5px;
      right: 5px;
      border-radius: 4px;
    }
  }
  .flex-fill:last-of-type {
    margin-bottom: 0 !important;
  }
  .icon {
    margin-right: 4px;
    svg {
      width: 24px;
      height: 24px;
    }
  }
  .content-title {
    a {
      font-weight: 600;
      font-size: 14px;
      display: block;
    }
    .meta {
      font-size: 12px;
      -webkit-text-fill-color: ${colors['text-secondary']};
      color: ${colors['text-secondary']};
    }
  }
`

export const Card = styled.div`
  background: #fbfbff;
  padding: 14px;
  border: 1px solid #e3e7f0;
  display: inline-flex;
  align-items: center;
  margin-bottom: 30px;
`
export const AddMemberPlanSummary = styled.ul`
  list-style: disc;
  margin-bottom: 0;
  padding: 6px 12px;
  li {
    margin-bottom: 5px;
    font-feature-settings: 'lnum';
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`

export const BilingFinalCost = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-feature-settings: 'lnum';
  .price_box {
    font-size: 68px;
    display: flex;
    align-items: start;
    line-height: 1em;
    .currency {
      line-height: 2;
      margin-right: 5px;
      font-size: 24px;
      font-weight: 600;
      -webkit-text-fill-color: ${colors['text-secondary']};
      color: ${colors['text-secondary']};
    }
    .net_amount {
      font-weight: 600;
      &.year {
        color: ${colors['main-blue']};
      }
    }
  }
  .user-length {
    font-size: 1.2rem;
  }
`
export const SubscriptionSuccess = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  svg {
    height: 100px;
    width: 100px;
  }
`

export const ReactSelectStyled = styled(ReactSelect)`
  &.required-flag .select-control__placeholder::after{
    content: "*";
    color: red;
    font-weight: bold;
    font-size: 1.3rem;
    position: absolute;
    top: 8px;
    right: 5rem;

  }

  .select-control__control {
    border-radius: 0;
    border: none;
    border-bottom: 1px solid ${colors['light-blue-200']};
    font-size: 16px;
    min-height: 32px;
    max-height: 32px;
    box-shadow: none;
    &:hover {
      border-color: ${colors['main-text']};
    }
    .select-control__indicators {
      .select-control__clear-indicator {
        cursor: pointer;
      }
    }
    .select-control__indicator {
      padding: 8px 4px;
      svg {
        width: 16px;
        height: 16px;
      }
    }
    .select-control__placeholder {
      font-size: 12px;
      color: ${colors['text-secondary']};
    }
    &--is-focused {
      .select-control__placeholder {
        top: -20px;
      }
    }
  }
  &.error {
    .select-control__control {
      border-bottom-color: ${colors.red};
    }
  }
`

export const GlobalSearchButton = styled.div`
  display: flex;
  align-items: center;
  border-radius: 100px;
  svg {
    stroke: ${colors['text-secondary']};
  }
  &:hover {
    color: ${colors['main-blue']};
  }
`
export const GlobalSearchModalStyled = styled(Modal)`
  max-width: 600px;
  .modal-content {
    border-radius: 4px;
    .modal-body {
      min-height: 300px;
      padding: 0;
      .search-box {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid ${colors['main-blue']};
        svg {
          stroke: ${colors['text-secondary']};
        }
        input {
          margin-left: 8px;
          font-size: 16px;
          height: 24px;
          border: none;
        }
      }
    }
  }
`
export const RecentSearches = styled.div`
  .label {
    padding: 8px 24px;
    font-size: 12px;
    -webkit-text-fill-color: ${colors['text-secondary']};
    color: ${colors['text-secondary']};
    font-weight: 600;
  }
`
export const SearchResults = styled.div`
  .filterButtons {
    padding: 16px 24px;
    display: flex;
    button {
      margin-right: 8px;
    }
  }
`
export const SearchItems = styled.ul`
  max-height: 300px;
  overflow: auto;
  li {
    position: relative;
    border-bottom: 1px solid #f4f4f8;
    display: flex;
    padding: 9px 24px;
    margin: 2px 0;
    .content-info {
      line-height: 18px;
      margin-left: 8px;
      width: 100%;
      .title {
        display: flex;
        align-items: center;
      }
      .category-info {
        margin-top: 5px;
        font-size: 12px;
        -webkit-text-fill-color: ${colors['text-secondary']};
        color: ${colors['text-secondary']};
        line-height: 18px;
      }
    }
    .content {
      margin-top: 8px;
      font-size: 12px;
      line-height: 18px;
    }
    &.disabled .show-upgrade-button {
      display: flex;
    }
  }
`

export const GraceNotification = styled.div`
  text-align: center;
  padding: 5px 15px;
  background: ${colors['main-blue']};
  font-size: 12px;
  color: #fff;
  display: flex;
  align-items: center;
  .close {
    border: 1px solid #fff;
    border-radius: 20px;
    svg {
      stroke: #fff;
      path {
        stroke: #fff;
      }
    }
  }
`
export const SharingGlobeDiv = styled.div`
  display: flex;
  align-items: flex-start;
  .header {
    flex: 1;
    padding-left: 0.5rem;
  }
  .head {
    font-size: 16px;
    font-weight: 600;
    color: ${colors['main-text']};
    margin: 0;
  }
  .sub-title {
    font-size: 12px;
    color: #7f82a2;
    font-weight: 600;
  }
`
export const CopyLink = styled.div`
  .copy {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 0.5rem;
    margin-bottom: 1.5rem;
    border-bottom: 1px solid #c8d1e6;
    overflow: hidden;
    flex-wrap: wrap;
    align-items: center;
    p {
      flex: 1;
      color: ${colors['text-secondary']};
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-overflow: ellipsis;
      height: 24px;
      overflow: hidden;
      margin: 0;
      white-space: nowrap;
    }
  }
  .password-toggle {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;
    p {
      flex: 1;
      font-weight: 400;
      font-size: 16px;
      line-height: 19px;
      color: ${colors['main-text']};
    }
  }
  .cancle {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
  }
`
export const TemplateEmoji = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .form-control {
    padding-left: 2rem;
  }
  .dropdown {
    position: absolute;
    left: 0;
    .emoji-picker-react {
      box-shadow: none;
      border: none;
    }
    .toggle {
      cursor: pointer;
      font-size: 1.2rem;
    }
    .dropdown-item {
      border-radius: 5px;
    }
  }
`

export const TemplateTabsTitle = styled.div`
  font-family: 'PT Serif';
  font-size: 20px;
  font-weight: 400;
  line-height: 27px;
  margin-bottom: 16px;
  text-align: left;
`


export const ResponseCardDropdownStyle = styled.div`
  display: flex;
  will-change: transform;
  /* transform: translate3d(-139px, 14px, 0px); */
  border-right: 2px solid #0d55ff;
  padding-top: 12px;

  margin-top: 0;

  border: 1px solid #f4f4ff;
  padding-top: 12px 0px;
  border-radius: 0;
  min-width: 200px;
  position: absolute !important;
  left: 9px !important;
  border-left: 2px solid #0d55ff;
  box-shadow: 0 4px 8px rgb(24 24 24 / 20%);

  display: block;

  /* z-index: 1000; */
  /* display: none; */
  float: left;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;

  & div{
    padding: 12px 15px;
    border: none !important;

    display: flex;

    align-items: center;

    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;

    font-size: 1rem;
    list-style: none;
    font-family: 'Raleway','Segoe UI',Helvetica,Arial,sans-serif;
    user-select: none;
    cursor: pointer;

    &:hover{
      background: #e9ecef;
    }
    & svg{
      margin-right: 8px;
    }

    &#delete{
      padding: 12px 15px;
      margin: 24px 0 0;
      color: #ff4343 !important
    }
  }
`

export const PageCardDropdownStyle = styled.div`
  display: flex;
  will-change: transform;
  /* transform: translate3d(-139px, 14px, 0px); */
  border-right: 2px solid #0d55ff;
  padding-top: 12px;

  margin-top: 0;

  border: 1px solid #f4f4ff;
  padding-top: 12px 0px;
  border-radius: 0;
  min-width: 200px;
  position: absolute !important;
  left: 9px !important;
  border-left: 2px solid #0d55ff;
  box-shadow: 0 4px 8px rgb(24 24 24 / 20%);

  display: block;

  /* z-index: 1000; */
  /* display: none; */
  float: left;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;

  & div{
    padding: 12px 15px;
    border: none !important;

    display: flex;

    align-items: center;

    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;

    font-size: 1rem;
    list-style: none;
    font-family: 'Raleway','Segoe UI',Helvetica,Arial,sans-serif;
    user-select: none;
    cursor: pointer;

    &:hover{
      background: #e9ecef;
    }
    & svg{
      margin-right: 8px;
    }

    &#delete{
      padding: 12px 15px;
      margin: 24px 0 0;
      color: #ff4343 !important
    }
  }
`

export const CatContentCoverStyle = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  font-size: 0.85rem;
  text-align: center;
  min-height: 3.71rem;
  max-width: 78.5rem;
  width: 100%;
  margin: auto;

  &:hover .zero-state{
    opacity: 1;
    display: flex;
  }

  & .zero-state{
    display: flex;
    font-weight: 600;
    position: absolute;
    left:${props => !props.unassignLeftSpace ? '1.4rem' : 0};
    top: 5px;
    z-index: 40;
    gap: 0.7rem;
    height: 1.71rem;
    opacity: ${props => props.showZeroState ? 1 : 0};
    height: 1.8rem;
    transition: all .4s ease-in-out;

    & div{
      height: 1.71rem;
      border: 1px solid #C8D1E5;
      padding: 0;
      position: relative;
      border-radius: 4.5rem;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 5px; 
      cursor: pointer;
      background: #fff;

        &:nth-of-type(2){
          & p{
            left: 33px;
          }
        }
        &  p{
          position: absolute;
          top: 2px;
          left: 30px;
        }
    }

    &__add-icon{
      width: 7.07rem;
      position: relative;
      padding: 0 12px !important;

      & ~ .icon-dropdown{
        display: flex;
        flex-direction: column;
        background-color: #fff;
        width: 14.6rem;
        height: 5.21rem;
        border-radius: .42rem;
        position: absolute;
        z-index: 3;
        left: 0;
        top: 1.7rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.14rem;
        justify-content: space-evenly;
        align-items: flex-start;
        box-shadow: 0px 4px 8px 0px #18181833;

        & :first-child{
          color: ${props => props.showEmoji ? '#0c55fe' : 'initial'};
          background: ${props => props.showEmoji ? '#F5F7FA' : 'initial'};

          &:hover{
            border-top-right-radius: .42rem;
            border-top-left-radius: .42rem;
          }
        }

        & :last-child{
          border-bottom-right-radius: .42rem;
          border-bottom-left-radius: .42rem;
        }

        & span{
          width: 100%;
          height: 100%;
          padding: 0;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5px 16px 1.5px 12px;

          &:hover{
            color: #0c55fe;
            background: #F5F7FA;
          }
        }
      }

      & ~ .emoji-picker{
      position: absolute;
      left: 15.5rem;
      top: 15.7rem;
      z-index: ${props => props.isfullscreen ? '300000000000' : '6'};
    }
    }

    &__add-cover{
      width: 10.7rem;
      padding: 0 12px !important;
    }
  }

  & .filled-state{
    display: block;
    position: relative;
    width: 100%; //63rem;
    height: 13.8rem;

    @media (max-width: 1024px) {
      width: 100%;
    }

    /* @media (max-width: 768px) {
      width: 100%; 
    } */

    @media (max-width: 425px) {
      height: 9rem;
    }

    &__cover{
      background-color: ${props => props.coverPreset ?? '#fff'};
      height: 85%;
      position: relative;

      &-control{
        position: absolute;
        display: flex;
        gap: 4px;
        right: 20px;
        top: 5px;
        z-index: 5;
        font-weight: 600;
        opacity: 0;
        transition: all .4s ease-in-out;

         & div{
            height: 1.71rem;
            border: 1px solid #C8D1E5;
            padding: 3px 16px 3px 12px;
            position: relative;
            border-radius: 4.5rem;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 5px; 
            cursor: pointer;
            background-color: #fff;

            & p{
              position: absolute;
              top: 2px;
              left: 30px;
            }

            @media (max-width: 425px) {
              height: 1rem;
              padding: 2px 8px 2px 6px;
              font-size: 0.6rem;
            }
          }
          &--add-cover{
            color: red;
          }
          @media (max-width: 425px) {
            font-weight: 500;
          }

           &--change-cover{
            width: 9rem;
            padding: 0 12px !important;
          }

          &--remove-cover{
            width: 6.8rem;
            padding: 0 12px !important;
          }
      }

      &-repositioning{
        position: absolute;
        display: flex;
        gap: 4px;
        right: 20px;
        bottom: 5px;
        z-index: 5;
        font-weight: 600;
        opacity: 0;
        transition: all .4s ease-in-out;

        & div{
            height: 1.71rem;
            border: 1px solid #C8D1E5;
            padding: 3px 12px 3px 12px;
            border-radius: 4.5rem;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            gap: 5px; 
            cursor: pointer;
            background-color: #fff;

            @media (max-width: 425px) {
              height: 1rem;
              padding: 2px 8px 2px 6px;
              font-size: 0.6rem;
            }

            & p{
              position: absolute;
              top: 2px;
              /* left: 10px; */
          }
        }
          

          &--reset{
            width: 5rem;
            padding: 0 12px !important;
          }

          &--reposition{
            width: 6.6rem;
            padding: 0 12px !important;
          }

          &--save{
            width: 3.8rem;
            padding: 0 12px !important;
          }
      }

      &--img-container{
        position: relative;
        overflow: hidden;
        height: 100%;
        display: flex;
        align-items: center;

        margin: 0 auto;
        /* width: 80vw; */
        cursor: ${props => !props.isDragging ? 'default' : 'grab'};

        & img{
          min-height: 100%;
	        min-width: 100%;
          position: absolute;
        }
      }

      & img{
        height: initial;
        width: 100%;
        object-fit: cover;
        position: 'absolute';
        bottom: '100px';
        right: '100px'
      }

      &:hover .filled-state__cover-control{
        opacity: 1;
      }

      &:hover .filled-state__cover-repositioning{
        opacity: 1;
      }
    }

    &__icon{
      height: 10.5rem;
      width: 10.5rem;
      border-radius: 7.5rem;
      border: 5.053px solid #fff;
      position: absolute;
      top: 45px;
      left: 114px;
      z-index: 3;
      overflow: hidden;
      font-weight: 500;
      transition: all .4s ease-in-out;
      background: #fff;
      cursor: ${props => !props.isViewer ? 'default' : 'pointer'};

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #0A215766;
        opacity: 0; 
        z-index: 1;
      }

      &:hover::before{
        opacity:${props => !props.isViewer ? '0' : '0.5'};
      }

      @media (max-width: 425px) {
        height: 7rem;
        width: 7rem;
        left: 50px;
      }

      &:hover img{
        filter: ${props => !props.isViewer ? 'none' : 'blur(2px)'};
      }

      &:hover p{
        filter: ${props => !props.isViewer ? 'none' : 'blur(2px)'};
      }

      & img{
        height: 100%;
        width: 100%;
        object-fit: cover;
        transition: all .4s ease-in-out;
        z-index: 2
      }

      & p{
        font-size: 124px;
        margin: ${props => props.isOSWindows ? '4.18rem 0' : '4.34rem 0'};
        height: 100%;
        z-index: 10;
        display: flex;
        justify-content: center;
      }
      /* & div{
        position: relative;
        width: 100%;
        height: 100%;
        z-index: 1100;
        background-color: orange;
      } */
      &:hover .filled-state__icon--button{
        opacity: 1;
      }

      &:hover + .filled-state__icon-cancel{
        opacity: 1;
      }

      &--button{
        position: absolute;
        background-color: red;
        left: 2rem;
        top: 4rem;
        background: #0A215766;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: .57rem;
        border-radius: 1.7rem;
        height: 1.7rem;
        width: 5.85rem;
        color: #fff;
        cursor: pointer;
        opacity: 0;
        transition: all .4s ease-in-out;
        z-index: 5;

        @media (max-width: 425px) {
              width: 4rem;
              top: 34.6px;
              left: 15.4px;
              height: 1.5rem;
        }
      }

      &-cancel{
        position: absolute;
        left: 15rem;
        top: 3rem;
        width: 2.1rem;
        height: 2.1rem;
        z-index: 1000;
        opacity: 0;
        transition: all .4s ease-in-out;
        cursor: pointer;

        @media (max-width: 425px) {
        left: 8rem;
        }
         
        &:hover{
          opacity: 1;
        }
      }

      & ~ .icon-dropdown{
        display: flex;
        flex-direction: column;
        background-color: #fff;
        width: 14.6rem;
        height: 5.21rem;
        border-radius: .42rem;
        position: absolute;
        z-index: 3;
        left: 10.5rem;
        top: 9.5rem;
        font-size: 1rem;
        line-height: 1.14rem;
        justify-content: space-evenly;
        align-items: flex-start;
        box-shadow: 0px 4px 8px 0px #18181833;

        & :first-child{
          color: ${props => props.showEmoji ? '#0c55fe' : 'initial'};
          background: ${props => props.showEmoji ? '#F5F7FA' : 'initial'};

          &:hover{
            border-top-right-radius: .42rem;
            border-top-left-radius: .42rem;
          }
        }

        & :last-child{
          border-bottom-right-radius: .42rem;
          border-bottom-left-radius: .42rem;
        }

        & span{
          width: 100%;
          height: 100%;
          padding: 0 1rem;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5px 16px 1.5px 12px;

          &:hover{
            color: #0c55fe;
            background: #F5F7FA;
          }
        }
      }
    }

    & .emoji-picker{
      position: absolute;
      left: 26rem;
      top: 10rem;
      z-index: ${props => props.isfullscreen ? '300000000000' : '6'};
    }
  }
`